// 获取学生的基本信息
export const STUDENT_GET_BASE_INFO = 'STUDENT_GET_BASE_INFO';
export const STUDENT_SET_BASE_INFO = 'STUDENT_SET_BASE_INFO';

// 获取学生最近课程安排信息
export const STUDENT_GET_RECENT_LESSON = 'STUDENT_GET_RECENT_LESSON';
export const STUDENT_SET_RECENT_LESSON = 'STUDENT_SET_RECENT_LESSON';
// 获取学生辅导科目
export const STUDENT_GET_TUTOR_SUBJECT = 'STUDENT_GET_TUTOR_SUBJECT';

// 获取备课列表
export const STUDENT_GET_LESSON_LIST = 'STUDENT_GET_LESSON_LIST';

// 获取作业列表
export const STUDENT_GET_HOMEWORK_LIST = 'STUDENT_GET_HOMEWORK_LIST';
export const STUDENT_SET_HOMEWORK_LIST = 'STUDENT_SET_HOMEWORK_LIST';

// 获取学生课程记录
export const STUDENT_GET_HISTORY_COURSE = 'STUDENT_GET_HISTORY_COURSE';
export const STUDENT_SET_HISTORY_COURSE = 'STUDENT_SET_HISTORY_COURSE';

// 获取学生详情信息(基本信息+课程信息)
export const STUDENT_GET_DETAIL = 'STUDENT_GET_DETAIL';
// 获取用户课时计划列表（正式）
export const STUDENT_GET_COURSE_PLANS = 'STUDENT_GET_COURSE_PLANS';

// 获取用户课时计划(正式)
export const STUDENT_GET_PLAN = 'STUDENT_GET_PLAN';
export const STUDENT_SET_PLAN = 'STUDENT_SET_PLAN';

// 获取用户课时试听列表
export const STUDENT_GET_FREE_LESSONS = 'STUDENT_GET_FREE_LESSONS';
// 课程规划操作
export const STUDENT_PLAN_EDIT_LESSON = 'STUDENT_PLAN_EDIT_LESSON';
export const STUDENT_PLAN_DELETE_LESSON = 'STUDENT_PLAN_DELETE_LESSON';
export const STUDENT_PLAN_ADD_LESSONS = 'STUDENT_PLAN_ADD_LESSONS';
export const STUDENT_PLAN_UP_LESSON = 'STUDENT_PLAN_UP_LESSON';
export const STUDENT_PLAN_DOWN_LESSON = 'STUDENT_PLAN_DOWN_LESSON';

// 修改课程规划
export const STUDENT_MODIFY_PLAN = 'STUDENT_MODIFY_PLAN';

// 获取学生列表
export const STUDENT_GET_LIST = 'STUDENT_GET_LIST';
export const STUDENT_SET_LIST = 'STUDENT_SET_LIST';

// 获取教材树打包信息
export const STUDENT_GET_KNPWLEDGE_TREE = 'STUDENT_GET_KNPWLEDGE_TREE';
export const STUDENT_SET_KNPWLEDGE_TREE = 'STUDENT_SET_KNPWLEDGE_TREE';
// 根据教材获取知识点
export const STUDENT_GET_KNPWLEDGE_LIST = 'STUDENT_GET_KNPWLEDGE_LIST';

// 获取筛选题目条件打包信息
export const STUDENT_GET_SELECTEXAM_TREE = 'STUDENT_GET_SELECTEXAM_TREE';
export const STUDENT_SET_SELECTEXAM_TREE = 'STUDENT_SET_SELECTEXAM_TREE';



// WEBPACK FOOTER //
// ./src/views/index/store/types/types_student.js